import { useReducer } from "react";
import { ExhaustiveCheckError } from "shared/errors";

export type EngravingFormState = {
    engravingName: string
    engravingDate1: string
    engravingDate2: string
    engravingSentiment: string
    quantity: number
}

export type EngravingFormAction
    = { type: "setEngravingName", value: string }
    | { type: "setEngravingDate1", value: string }
    | { type: "setEngravingDate2", value: string }
    | { type: "setEngravingSentiment", value: string }
    | { type: "setQuantity", value: number }

export type EngravingFormDispatch = React.Dispatch<EngravingFormAction>

type EngravingFormReducer = (state: EngravingFormState, action: EngravingFormAction) => EngravingFormState;

const reduce: EngravingFormReducer = (state, action) => {
    switch (action.type) {
        case "setEngravingName":
            return {...state, engravingName: action.value }
        case "setEngravingDate1":
            return {...state, engravingDate1: action.value }
        case "setEngravingDate2":
            return {...state, engravingDate2: action.value }
        case "setEngravingSentiment":
            return {...state, engravingSentiment: action.value }
        case "setQuantity":
            return {...state, quantity: action.value }
        default:
            throw new ExhaustiveCheckError(action)
    }
}

function mapInitialState(): EngravingFormState {
    return {
        engravingName: "",
        engravingDate1: "",
        engravingDate2: "",
        engravingSentiment: "",
        quantity: 1,
    }
}

export const useEngravingFormReducer: () => [EngravingFormState, EngravingFormDispatch] = () => {
    return useReducer<EngravingFormReducer, Partial<EngravingFormState>>(reduce, {}, mapInitialState);
}
